import { assert } from '@sama/js-core';
import { Camera, Vector3 } from 'three';
import { truncateToPoint2D } from '../../../../cross-team-shared/misc-utils';
import { Point2D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { CuboidLocationState3D } from '../../../state/cuboid-location-state-3d';
import { buildCuboidPointsFromShapeLocation } from '../../../utils/cuboid-utils';
import {
  getMouseContainerPoint,
  vectorToPoint,
} from '../../../utils/point-cloud-utils';
import { reducePoints } from '../../../utils/point-utils';

export interface NdcBoundingBox {
  min: Point2D;
  max: Point2D;
}

export function isPointInsideBox(point: Point2D, box: NdcBoundingBox) {
  return (
    point[0] >= box.min[0] &&
    point[0] <= box.max[0] &&
    point[1] >= box.min[1] &&
    point[1] <= box.max[1]
  );
}

export function getCuboidNdcBoundingBox(
  location: CuboidLocationState3D,
  camera: Camera,
): NdcBoundingBox {
  const points = buildCuboidPointsFromShapeLocation(location);
  const pointsInCamera = points
    .map((point) => new Vector3().fromArray(point).project(camera))
    .map(vectorToPoint)
    .map(truncateToPoint2D);

  const min = reducePoints(pointsInCamera, Math.min);
  const max = reducePoints(pointsInCamera, Math.max);

  return { min, max };
}

export function getContainerPoint(event: MouseEvent) {
  const container = event.currentTarget;
  assert(
    container && container instanceof HTMLElement,
    'Mouse event should have been triggered from an HTML element',
  );
  return getMouseContainerPoint(event, container);
}
